"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchTextInData = searchTextInData;
exports.getQueryParams = getQueryParams;
function stringify(data, timestamps) {
    switch (typeof data) {
        case 'string':
            return data;
        case 'number':
            return data.toString();
        case 'object':
            return Object.keys(data)
                .map(function (key) { return stringify(data[key]); })
                .join(' ');
        default:
            return '';
    }
}
function searchTextInData(text, data) {
    var terms = text
        .toLocaleLowerCase()
        .split(/[\s,.\(\)]+/)
        .filter(function (s) { return !!s.trim(); });
    var json = stringify(data).toLocaleLowerCase();
    for (var i = 0; i < terms.length; i++) {
        if (json.indexOf(terms[i]) < 0) {
            return false;
        }
    }
    return true;
}
function getQueryParams(params) {
    var a = Object.entries(params)
        .reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        if (value || typeof value === 'number') {
            acc.push("".concat(key, "=").concat(encodeURIComponent(value.toString())));
        }
        return acc;
    }, [])
        .join('&');
    return a ? "?".concat(a) : '';
}
